import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  Box, List, ListItemButton, ListItemIcon, ListItemText, Tooltip,
  Typography, LinearProgress,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AppHeader from "./AppHeader";
import AppShell from "./AppShell";
import MainContentScrollArea from "./MainContentScrollArea";
import { APP_HEADER_HEIGHT } from "./layoutConstants";
import { useAuth } from "../../context/AuthContext";

const SIDEBAR_WIDTH = 64;

const NAV_ITEMS = [
  { id: "overview",  label: "Overview",        icon: <DashboardIcon />,                    path: "/client/overview" },
  { id: "users",     label: "User Management",  icon: <PeopleOutlinedIcon />,               path: "/client/users" },
  { id: "roles",     label: "Roles",            icon: <AdminPanelSettingsOutlinedIcon />,   path: "/client/roles" },
  { id: "activity",  label: "Activity Log",     icon: <HistoryOutlinedIcon />,              path: "/client/activity" },
  { id: "settings",  label: "Settings",         icon: <SettingsOutlinedIcon />,             path: "/client/settings" },
];

export default function ClientLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();

  return (
    <AppShell>
      <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1200 }}>
        <AppHeader />
      </Box>

      {/* Sidebar */}
      <Box
        sx={{
          width: SIDEBAR_WIDTH,
          borderRight: "1px solid #eee",
          height: `calc(100vh - ${APP_HEADER_HEIGHT}px)`,
          position: "fixed",
          left: 0,
          top: APP_HEADER_HEIGHT,
          bgcolor: "#fafafa",
          zIndex: 1100,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 2,
        }}
      >
        <List sx={{ width: "100%", p: 0 }}>
          {NAV_ITEMS.map((item) => {
            const isSelected = pathname.startsWith(item.path);
            return (
              <Tooltip key={item.id} title={item.label} placement="right" arrow>
                <ListItemButton
                  selected={isSelected}
                  onClick={() => navigate(item.path)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 2,
                    px: 0,
                    minHeight: 64,
                    "&:hover": { backgroundColor: "#f5f5f5" },
                    "&.Mui-selected": {
                      backgroundColor: "#e3f2fd",
                      borderLeft: "3px solid #1976d2",
                      "&:hover": { backgroundColor: "#e3f2fd" },
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: "auto",
                      color: isSelected ? "#1976d2" : "inherit",
                      justifyContent: "center",
                      mb: 0.5,
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontSize: "10px",
                      fontWeight: isSelected ? 600 : 400,
                      color: isSelected ? "#1976d2" : "inherit",
                      textAlign: "center",
                    }}
                    sx={{ margin: 0 }}
                  />
                </ListItemButton>
              </Tooltip>
            );
          })}
        </List>
      </Box>

      <MainContentScrollArea ml={SIDEBAR_WIDTH} bgcolor="#f9fafb">
        <Outlet />
      </MainContentScrollArea>
    </AppShell>
  );
}
